import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import Classes from '../common/Classes';
import ProductImage from '../common/exhibitingOrganisation/ProductImage';
import { Devices, ScreenSizes } from '../common/Constants';
import Utils from '../common/Utils';


const ProductDirectoryImage = ({
  alt, imageSize, translations, isInnovative, isRounded, imageDataDtm, trackProductInteractedEvent, isVideoAvailable, product
}) => (
  <div className={Classes.productDirectoryImageContainer}>
    <MediaQuery minWidth={1199}>
      <ProductImage
        product={product}
        src={`${Utils.getProductVideoOrImageUrl(product)}?${new Date().getTime()}`}
        deviceType={`${Devices.desktop}-${ScreenSizes.small}`}
        imageSize={imageSize}
        alt={alt}
        isInnovative={isInnovative}
        translations={translations}
        isRounded={isRounded}
        imageDataDtm={imageDataDtm}
        trackProductInteractedEvent={trackProductInteractedEvent}
        isVideoAvailable={isVideoAvailable}
      />
    </MediaQuery>
    <MediaQuery minWidth={992} maxWidth={1198}>
      <ProductImage
        product={product}
        src={`${Utils.getProductVideoOrImageUrl(product)}?${new Date().getTime()}`}
        deviceType={`${Devices.desktop}-${ScreenSizes.small}`}
        imageSize={imageSize}
        alt={alt}
        isInnovative={isInnovative}
        translations={translations}
        isRounded={isRounded}
        imageDataDtm={imageDataDtm}
        trackProductInteractedEvent={trackProductInteractedEvent}
        isVideoAvailable={isVideoAvailable}
      />
    </MediaQuery>
    <MediaQuery minWidth={768} maxWidth={991}>
      <ProductImage
        product={product}
        src={`${Utils.getProductVideoOrImageUrl(product)}?${new Date().getTime()}`}
        deviceType={`${Devices.desktop}-${ScreenSizes.small}`}
        imageSize={imageSize}
        alt={alt}
        isInnovative={isInnovative}
        translations={translations}
        isRounded={isRounded}
        imageDataDtm={imageDataDtm}
        trackProductInteractedEvent={trackProductInteractedEvent}
        isVideoAvailable={isVideoAvailable}
      />
    </MediaQuery>
    <MediaQuery maxWidth={767}>
      <ProductImage
        product={product}
        src={`${Utils.getProductVideoOrImageUrl(product)}?${new Date().getTime()}`}
        deviceType={`${Devices.mobile}-${ScreenSizes.small}`}
        imageSize={imageSize}
        alt={alt}
        isInnovative={isInnovative}
        translations={translations}
        isRounded={isRounded}
        imageDataDtm={imageDataDtm}
        trackProductInteractedEvent={trackProductInteractedEvent}
        isVideoAvailable={isVideoAvailable}
      />
    </MediaQuery>
  </div>
);


ProductDirectoryImage.propTypes = {
  src: PropTypes.string.isRequired,
  imageSize: PropTypes.string.isRequired,
  alt: PropTypes.string,
  isRounded: PropTypes.bool,
  translations: PropTypes.shape({
    buttons: PropTypes.shape({
      edit: PropTypes.string
    }),
    innovativeClipText: PropTypes.string
  }).isRequired,
  isInnovative: PropTypes.bool,
  imageDataDtm: PropTypes.object,
  trackProductInteractedEvent: PropTypes.func,
  isVideoAvailable: PropTypes.bool
};

export default ProductDirectoryImage;
